import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/views/MainPage/LoginPage.vue'
import LandingPage from '@/views/MainPage/LandingPage.vue'
import PrivacyPolicyPage from '@/views/MainPage/PrivacyPolicyPage.vue'

const routes = [
  {
    path: '/Landing',
    name: 'Landing',
    component: LandingPage
  },
  {
    path: '',
    name: 'Login',
    component: Login
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicyPage
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router